import { LinearProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { passRate, Tally } from "@internal/plugin-front-door-common";

const useStyles = makeStyles((theme) => ({
  bar: { height: 8, borderRadius: 4 },
  fail: { backgroundColor: theme.palette.warning.main },
  pass: { backgroundColor: theme.palette.success.main },
}));

/** The share of scored checks that pass; full and green only when all do. */
export function PassBar(props: {
  tally: Pick<Tally, "passed" | "total">;
  label: string;
}) {
  const classes = useStyles();
  const { tally, label } = props;
  return (
    <LinearProgress
      variant="determinate"
      value={(passRate(tally) ?? 0) * 100}
      aria-label={label}
      className={classes.bar}
      classes={{
        bar: tally.passed === tally.total ? classes.pass : classes.fail,
      }}
    />
  );
}
